// Customizer const
export const PATHNAME = 'PATHNAME';

//Auth const
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const INIT_URL = 'INIT_URL';

//Sidebar right
export const SET_SIDEBAR_RIGHT = "SET_SIDEBAR_RIGHT";
export const SET_SIDEBAR_CONTENT = "SET_SIDEBAR_CONTENT";
export const SET_SIDEBAR_INFO = "SET_SIDEBAR_INFO";


//Employees
export const GET_EMPLOYESS = "GET_EMPLOYESS";
export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE";
export const DELETE_EMPLOYEE = "DELETE_EMPLOYEE";
export const EDIT_EMPLOYEE = "EDIT_EMPLOYEE";
export const SET_SELECTED_EMPLOYEE = "SET_SELECTED_EMPLOYEE";


//Specialties
export const GET_SPECIALITIES = "GET_SPECIALITIES";
export const CREATE_SPECIALTY = "CREATE_SPECIALTY";
export const EDIT_SPECIALTY = "EDIT_SPECIALTY";
export const DELETE_SPECIALTY = "DELETE_SPECIALTY";
export const SET_SELECTED_SPECIALITY = "SET_SELECTED_SPECIALITY";

//SUB-Specialties
export const GET_SUB_SPECIALITIES = "GET_SUB_SPECIALITIES";
export const SET_SELECTED_SUB_SPECIALITIES = "SET_SELECTED_SUB_SPECIALITIES";
export const CREATE_SUB_SPECIALTY = "CREATE_SUB_SPECIALTY";
export const EDIT_SUB_SPECIALTY = "EDIT_SUB_SPECIALTY";
export const DELETE_SUB_SPECIALTY = "DELETE_SUB_SPECIALTY";



//Clinical case quiz
export const SET_SELECTED_CLINICAL_CASE = "SET_SELECTED_CLINICAL_CASE";
export const GET_CLINICAL_CASES = "GET_CLINICAL_CASES";
export const SET_FILTERS_CLINICAL_CASES = "SET_FILTERS_CLINICAL_CASES";
export const RESET_FILTERS = "RESET_FILTERS";
export const RESET_CLINICAL_CASE = "RESET_CLINICAL_CASE";
export const NEW_CLINICAL_CASE = "NEW_CLINICAL_CASE";
export const DELETE_CLINICAL_CASE = "DELETE_CLINICAL_CASE";
export const EDIT_CLINICAL_CASE = "EDIT_CLINICAL_CASE";
export const EDIT_CLINICAL_TEXT = "EDIT_CLINICAL_TEXT";
export const SET_STATUS = "SET_STATUS";
export const SET_EDIT_STATUS = "SET_EDIT_STATUS";


//Quiz questions
export const EDIT_QUESTION = "EDIT_QUESTION";
export const ADD_QUESTION = "ADD_QUESTION";
export const DELETE_QUESTION = "DELETE_QUESTION";
export const EDIT_QUESTION_JUSTIFICATION = "EDIT_QUESTION_JUSTIFICATION";
export const STATUS_QUESTION_LANGUAGE = "STATUS_QUESTION_LANGUAGE";
export const ADD_ANSWER = "ADD_ANSWER";
export const EDIT_ANSWER = "EDIT_ANSWER";
export const DELETE_ANSWER = "DELETE_ANSWER";
export const ADD_IMAGES = "ADD_IMAGES";
export const DELETE_IMAGES = "DELETE_IMAGES";
export const CORRECT_ANSWER = "CORRECT_ANSWER";
export const ADD_REFERENCE = "ADD_REFERENCE";
export const EDIT_REFERENCE = "EDIT_REFERENCE";
export const DELETE_REFERENCE = "DELETE_REFERENCE";
export const ADD_COMMENT = "ADD_COMMENT";
export const EDIT_COMMENT = "EDIT_COMMENT";
export const DELETE_COMMENT = "DELETE_COMMENT";